import { ref, reactive } from 'vue';

const notifications = ref([]);
let nextId = 1;

export function useNotifications() {
  const addNotification = (notification) => {
    const id = nextId++;
    const newNotification = {
      id,
      type: notification.type || 'info',
      title: notification.title,
      message: notification.message || '',
      duration: notification.duration || 5000,
      show: true,
    };

    notifications.value.push(newNotification);

    // Автоматически удаляем уведомление через указанное время
    if (newNotification.duration > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, newNotification.duration);
    }

    return id;
  };

  const removeNotification = (id) => {
    const index = notifications.value.findIndex((n) => n.id === id);
    if (index > -1) {
      notifications.value.splice(index, 1);
    }
  };

  const clearAll = () => {
    notifications.value = [];
  };

  // Удобные методы для разных типов уведомлений
  const success = (title, message = '', duration = 5000) => {
    return addNotification({ type: 'success', title, message, duration });
  };

  const error = (title, message = '', duration = 7000) => {
    return addNotification({ type: 'error', title, message, duration });
  };

  const warning = (title, message = '', duration = 6000) => {
    return addNotification({ type: 'warning', title, message, duration });
  };

  const info = (title, message = '', duration = 5000) => {
    return addNotification({ type: 'info', title, message, duration });
  };

  return {
    notifications: notifications.value,
    addNotification,
    removeNotification,
    clearAll,
    success,
    error,
    warning,
    info,
  };
}
